<template>
    <div id="q-app">
        <router-view />
    </div>
</template>
<script>
const stringBanks = [];
export default {
    name: 'App',
}
</script>
